import { Navigate } from "react-router-dom";
import { AuthRoles } from "../../models/roles.model";
import { RolesService } from "../../services/session/roles.service";

/**
 * Settings landing route. The management tabs (Users / Message Templates / Marketing
 * Campaigns) are each guarded by allowedRoles=[ADMIN], so only a full admin can open
 * them. We mirror that exact guard here so the landing never sends a user toward a tab
 * they can't access: land on Users only if the user passes the same ADMIN check,
 * otherwise land on Preferences (the only tab open to everyone).
 *
 * This keeps Coach Coordinators — who are NOT permitted on the management tabs — on
 * Preferences like regular coaches, instead of being routed to Users and immediately
 * bounced out to the Call Center by the route guard.
 */
const SettingsIndexRedirect = () => (
	<Navigate
		to={RolesService.hasValidRoles(undefined, [AuthRoles.ADMIN]) ? "users" : "preferences"}
		replace
	/>
);

export default SettingsIndexRedirect;
